export async function uploadFileToS3(uploadUrl, file) {
    try {
        const response = await fetch(uploadUrl, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': file.type,
                // Add any additional headers if needed
            },
        });

        if (response.ok) {
            // File uploaded successfully
        } else {
            // Failed to upload file
        }
    } catch (error) {
        // Error uploading file
    }
};